import React from "react";

const Signature = props => {
  return <p>{props.signature}</p>;
};

export default Signature;
